import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { countOfSelectedGoodieProductsSelector } from 'swag-client-common/redux/goodie-giveaway/selectors/goodie-giveaway-selection.selectors';
import { CatalogScrollContinueBlockComponent } from './catalog-scroll-continue-block';
const mapStateToProps = createStructuredSelector({
  showStickyFooter: state => Boolean(countOfSelectedGoodieProductsSelector(state))
});
export const CatalogScrollContinueBlock = connect(mapStateToProps)(CatalogScrollContinueBlockComponent);